import { catalogApi as api } from '../../../api/catalog';

/**
 * Creates optimistic add/remove handlers for autocomplete-multiple-chips fields
 */
export const createMultiChipHandlers = ({
    fieldName,
    getItemValue = (item) => item.value,
    setItemInformation,
    setNotification,
}) => {
    const setFieldValue = (externalSku, value) => {
        setItemInformation((items) =>
            items.map((item) => (item.externalSku === externalSku ? { ...item, [fieldName]: value } : item)),
        );
    };

    const updateField = async (row, updatedValues, successMessage) => {
        const previousValue = row[fieldName];
        setFieldValue(row.externalSku, updatedValues);

        const formData = new FormData();
        formData.append(fieldName, JSON.stringify(updatedValues));
        formData.append('externalSku', row.externalSku);
        const res = await api.updateItemInformation(formData);

        if (res.status === true) {
            setNotification({ level: 'success', text: successMessage });
            return true;
        }

        setFieldValue(row.externalSku, previousValue);
        setNotification({ level: 'error', text: res.msg || `Failed to update ${fieldName}` });
        return false;
    };

    const addItem = async ({ row, values }) => {
        const currentValues = row[fieldName] || [];
        const validValues = values.filter((v) => v != null && v !== '' && !currentValues.includes(v));
        const uniqueValues = [...new Set(validValues)];

        if (!uniqueValues.length) {
            setNotification({ level: 'error', text: 'Must specify values.' });
            return false;
        }

        const updatedValues = [...currentValues, ...uniqueValues];
        return updateField(row, updatedValues, `${fieldName} updated successfully!`);
    };

    const removeItem = async ({ item, row }) => {
        const itemValue = getItemValue(item);
        const updatedValues = (row[fieldName] || []).filter((value) => value !== itemValue);
        return updateField(row, updatedValues, `${fieldName} item removed!`);
    };

    return { addItem, removeItem };
};
